import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { getRapydPaymentResult } from '../../core/payment/rapyd/sendRapydPayment';
import messages from '../../locale/messages';
import s from './RapydComplete.css';

class RapydComplete extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      paymentStatus: 'checking',
      reservationId: null,
      checkCount: 0
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const reservationId = urlParams.get('reservationId') || window.localStorage.getItem('pendingReservationId');
    
    if (reservationId) {
      this.setState({ reservationId });
      this.checkPaymentStatus(reservationId);
    } else {
      this.setState({ loading: false, paymentStatus: 'error' });
    }
  }

  checkPaymentStatus = async (reservationId) => {
    try {
      const result = await getRapydPaymentResult(reservationId);
      
      if (result.status === 200) {
        this.setState({ loading: false, paymentStatus: 'completed' });
        window.localStorage.removeItem('pendingReservationId');
        
        setTimeout(() => {
          window.location.href = `/users/trips/itinerary/${reservationId}`;
        }, 3000);
      } else if (this.state.checkCount < 3) {
        this.setState(prevState => ({ checkCount: prevState.checkCount + 1 }));
        setTimeout(() => this.checkPaymentStatus(reservationId), 2000);
      } else {
        this.setState({ loading: false, paymentStatus: 'pending' });
      }
    } catch (error) {
      this.setState({ loading: false, paymentStatus: 'error' });
    }
  }

  render() {
    const { loading, paymentStatus } = this.state;

    if (loading) {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <h1><FormattedMessage {...messages.processing} /></h1>
            <p><FormattedMessage {...messages.pleaseWaitPayment} /></p>
          </div>
        </div>
      );
    }

    if (paymentStatus === 'completed') {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <h1><FormattedMessage {...messages.success} /></h1>
            <p><FormattedMessage {...messages.redirectToBooking} /></p>
          </div>
        </div>
      );
    }

    if (paymentStatus === 'pending') {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <h1><FormattedMessage {...messages.processing} /></h1>
            <p><FormattedMessage {...messages.paymentStillProcessing} /></p>
            <p>
              <FormattedMessage {...messages.closeWindowOrReturn} />
              {' '}<a href="/"><FormattedMessage {...messages.returnToHomepage} /></a>.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1><FormattedMessage {...messages.error} /></h1>
          <p><FormattedMessage {...messages.paymentVerificationFailedDetail} /></p>
          <p>
            <FormattedMessage {...messages.checkBookings} />
            {' '}<a href="/user/trips"><FormattedMessage {...messages.viewBookings} /></a>
            {' '}<FormattedMessage {...messages.or} />
            {' '}<a href="/"><FormattedMessage {...messages.returnToHomepage} /></a>.
          </p>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  // Add any state you need here
});

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState)
)(RapydComplete);
